module.exports = __webpack_public_path__ + "img/wandh-guideline-active.fab1aa6.svg";